import { lazy } from 'react';

export const PlayerCancelWagerLimitForm = lazy(
  () => import('./PlayerCancelWagerLimitForm'),
);
